import api from './api';

const analyticsService = {
  // Get analytics dashboard overview
  getDashboard: () => {
    return api.get('/api/admin/analytics/dashboard');
  },

  // Get revenue analytics
  getRevenueChart: (period = '30d') => {
    return api.get('/api/analytics/revenue', { params: { period } });
  },

  // Get orders analytics - included in dashboard
  getOrdersChart: (period = '30d') => {
    return api.get('/api/analytics/dashboard', { params: { period } });
  },

  // Get sales by category - not implemented yet
  getSalesByCategory: () => {
    return api.get('/api/analytics/sales-by-category');
  },

  // Get top products analytics
  getTopProducts: (limit = 5) => {
    return api.get('/api/analytics/products', { params: { limit } });
  },

  // Get recent activity
  getRecentActivity: (limit = 10) => {
    return api.get('/api/analytics/activity', { params: { limit } });
  },

  // Get traffic sources
  getTrafficSources: () => {
    return api.get('/api/analytics/traffic-sources');
  },

  // Get visitors by country
  getVisitorsByCountry: () => {
    return api.get('/api/analytics/visitors-by-country');
  },

  // Get customer analytics
  getCustomerAnalytics: () => {
    return api.get('/api/analytics/customers');
  },

  // ============================================
  // Google Analytics endpoints (requires GA4 setup)
  // ============================================

  // Get GA overview metrics
  getGAOverview: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/overview', {
      startDate,
      endDate,
    });
  },

  // Get GA traffic sources
  getGATrafficSources: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/traffic-sources', {
      startDate,
      endDate,
    });
  },

  // Get GA visitor metrics (visitors by country)
  getGAVisitorsByCountry: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/visitor-metrics', {
      startDate,
      endDate,
    });
  },

  // Get GA page views
  getGAPageViews: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/page-views', {
      startDate,
      endDate,
    });
  },

  // Get GA user demographics
  getGADemographics: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/user-demographics', {
      startDate,
      endDate,
    });
  },

  // Get GA real-time users
  getGARealtime: () => {
    return api.get('/api/admin/google-analytics/realtime');
  },

  // Get GA e-commerce data
  getGAEcommerce: (startDate, endDate) => {
    return api.post('/api/admin/google-analytics/ecommerce', {
      startDate,
      endDate,
    });
  },

  // ============================================
  // Product Analytics API (GA4 + Orders Database)
  // Docs: docs/others/cms_product_implementation/docs/23-product-analytics-frontend-integration-guide.md
  // ============================================

  // Get product metrics - combines GA4 views with Orders DB conversions
  // period: '7d', '30d', '90d', '1y'
  // sortBy: 'revenue', 'conversions', 'views'
  getProductMetrics: (period = '30d', limit = 5, sortBy = 'revenue') => {
    return api.get('/api/admin/analytics/products/metrics', {
      params: { period, limit, sortBy }
    });
  },

  // Get GA configuration status
  getGAStatus: () => {
    return api.get('/api/admin/google-analytics/status');
  },

  // Save GA configuration
  saveGAConfig: (propertyId, serviceAccountJson) => {
    return api.post('/api/admin/google-analytics/config', {
      propertyId,
      serviceAccountJson,
    });
  },

  // Get GA configuration
  getGAConfig: () => {
    return api.get('/api/admin/google-analytics/config');
  },

  // Test GA connection
  testGAConnection: () => {
    return api.post('/api/admin/google-analytics/test');
  },
};

export default analyticsService;
